import React from "react";
import { useTranslation } from "react-i18next";

const Meals = () => {
  const { t } = useTranslation();

  return (
    <div className="list-trip">
      <h4>{t("titleMeals")}</h4>
      <ul className="list-unstyled p-0 m-0">
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="mealCheck1" />
              <label className="form-check-label" htmlFor="mealCheck1">
                {t("kitchen")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">120</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="mealCheck2" />
              <label className="form-check-label" htmlFor="mealCheck2">
                {t("breakfast")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">21</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="mealCheck3" />
              <label className="form-check-label" htmlFor="mealCheck3">
                {t("allMeals")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">62</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="mealCheck4" />
              <label className="form-check-label" htmlFor="mealCheck4">
                {t("allInclusive")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">33</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="mealCheck5" />
              <label className="form-check-label" htmlFor="mealCheck5">
                {t("breakfastLunch")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">25</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="mealCheck6" />
              <label className="form-check-label" htmlFor="mealCheck6">
                {t("breakfastDinner")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">65</div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Meals;
